import { POS_ROUTE } from "../../../constants/constants"

export const RECEIPT_COMPOSER_ROUTE = POS_ROUTE + "/receipt-composer"